export default __webpack_public_path__ + "static/media/img_04.18c235db.jpg";